import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0ff65c1c&scoped=true&lang=pug&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=0ff65c1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff65c1c",
  null
  
)

/* custom blocks */
import block0 from "./list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsInsuranceCarInsuranceNoQuotesReason: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/products/insurance/car-insurance/no-quotes-reason.vue').default})
